export const POLICY_FILE_TYPE = 'POLICY'
export const POLICY_CONFIRMATION_FILE_TYPE = 'POLICY_CONFIRMATION'
